import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, LogIn } from "lucide-react";
import { toast } from "sonner";
import { adminLogin } from "@/lib/api";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(form);
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_username", res.data.username);
      toast.success("Bienvenido al panel de administración");
      navigate("/admin");
    } catch (e) {
      toast.error("Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F9FAFB] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Leaf className="w-8 h-8 text-forest" strokeWidth={1.5} />
            <span className="font-heading text-2xl font-bold text-forest">Oymer</span>
          </div>
          <p className="font-body text-sm text-sage">Panel de Administración</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm">
          <div className="space-y-4">
            <div>
              <label className="block font-body text-sm font-medium text-gray-700 mb-1.5">Usuario</label>
              <input
                type="text"
                data-testid="admin-username-input"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                className="w-full rounded-lg border border-gray-200 px-4 py-2.5 font-body text-sm focus:border-forest focus:outline-none focus:ring-2 focus:ring-forest/20"
                required
              />
            </div>
            <div>
              <label className="block font-body text-sm font-medium text-gray-700 mb-1.5">Contraseña</label>
              <input
                type="password"
                data-testid="admin-password-input"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full rounded-lg border border-gray-200 px-4 py-2.5 font-body text-sm focus:border-forest focus:outline-none focus:ring-2 focus:ring-forest/20"
                required
              />
            </div>
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full mt-6 bg-forest text-white rounded-lg px-4 py-2.5 font-body text-sm font-medium transition-colors hover:bg-forest-dark disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <LogIn size={16} /> {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}
